<template >
  <div :style="backGroudConfig" >


      <el-card style="position: fixed;left: 23%;border-radius: 20px;background-color: rgba(255, 255, 255, 0.8);top: 35%;width:50%;height: 25%" shadow="always">


        <div style="margin-top: 2%;">
          <el-text  size="large" type="primary" style="font-weight: bold;margin-left: 15px">卡密: </el-text><el-input v-model="username" style="background-color: rgba(255, 255, 255, 0.8);width: 66%;" placeholder="请输入你的卡密" />
        </div>
        <div style="margin-top: 5%">
          <el-button :disabled = "resetting" style="font-weight: bold;width: 25%" plain type="info" round @click="reset">卡密解绑</el-button>
          <el-button :disabled = "resetting" style="font-weight: bold;width: 25%" plain type="info" round @click="queryInfo">查询到期</el-button>
        </div>
        <div style="margin-top: 2%;">
          <span style="font-size: 20px;font-weight: bold;text-decoration: none;">{{buytext}}</span>
          <a v-show="buyurl.length > 1" :href="buyurl" style="font-size: 20px;font-weight: bold;text-decoration: none;color: red">(点我跳转购买页面)</a>
        </div>
      </el-card>

    <div class="advertisement">
      <el-card  style="background-color: rgba(255, 255, 255, 0.6);">
        <template #header>
          <div style="font-weight: bold">公告</div>
        </template>
        <div v-if="adv.text != null && adv.text.length > 0">
          <p :key="i" v-for="(item,i) in adv.text.split('\n')" type="warning" :style="advConfig">
            {{item}}
          </p>

        </div>
      </el-card>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ResetPage',
  data(){
    return{
      boss:"",
      backgroundUrl:"",
      buyurl:"",
      buytext:"",
      adv: {
        text: "绿色游戏健康生活，坚决抵制破坏国内游戏环境！！请勿交流任何关于国内平台的游戏！\n" +
            "\n" +
            "软件仅供学习交流使用，请勿用于国内平台，软件请在24小时内自行删除，否则后果自负！\n" +
            "\n" +
            "购买卡密后请尽快使用，本站出售的均为未使用卡密，请妥善保管您的卡密！！\n" +
            "\n" +
            "售后 解绑 疑难杂症等问题带订单联系客服即可，不带订单不回！不带订单不回！\n" +
            "\n" +
            "摁F严禁一人拥有多个账户 包括但不限于HWID相同 账号id相似等等\n" +
            "\n" +
            "如您将账号出售 出租 或注册多个账号导致封禁 不在我们售后范围内",
        color: "#f9963b"
      },
      username:"",
      no:"",
      reason:"",
      resetting: false
    }
  },
  methods: {
    flushUI() {
      this.$axios.get('/global/getUiConfig',{params:{"key":1}}).then(res => {
        if (res.data.code == 1) {
          let arr = res.data.data;
          for (let i = 0; i < arr.length; i++) {
            let e = arr[i];
            switch (e.type) {
              case 0:
                this.backgroundUrl = e.url;
                break;
              case 1:
                this.adv.color = e.color;
                break;
            }
          }

        }
      });


      this.$axios.get('/global/getNotice',{params:{"boss":this.boss}}).then(res => {
          let e = res.data;


        this.adv.text = e.color;
        this.buyurl = e.detail;
        this.buytext = e.text;




          if (e.type != 3) {
            window.location.href = 'https://www.baidu.com/';
          }

      });


    },
    reset() {
      if (this.username.length == 0) {
        this.$message.error("请输入解绑卡密");
        return;
      }
      this.resetting = true;
      console.log(this.boss)
      this.$axios.get('/global/resetByUser', {
        params: {
          boss: this.boss,
          card: this.username
        }
      }).then(res => {
        this.$message.success(res.data);
        this.resetting = false;
      }).catch(() => {
        this.$message.error("未知错误!");
        this.resetting = false;
      });
    },
    queryInfo() {
      if (this.username.length == 0) {
        this.$message.error("请输入查询卡密");
        return;
      }
      this.resetting = true;
      console.log(this.boss)
      this.$axios.get('/global/queryCardInfoByUser', {
        params: {
          boss: this.boss,
          card: this.username
        }
      }).then(res => {
        this.$message.success(res.data);
        this.resetting = false;
      }).catch(() => {
        this.$message.error("未知错误!");
        this.resetting = false;
      });
    },
  },
  mounted() {
    this.boss = this.$route.params.param;
    this.flushUI();
  },
  computed: {
    // 使用计算属性来生成样式对象
    backGroudConfig() {
      return {
        marginTop: '-63px',
        height: '100%',
        width: '100%',
        // 使用动态数据变量来设置背景图片 URL
        background: `url('${this.backgroundUrl}') fixed no-repeat`,
        backgroundSize: 'cover',
        position: 'fixed'
      };
    },
    advConfig(){
      return{
        fontSize: '14px',
        color: this.adv.color,
        textAlign: 'left',
        fontWeight:'bold',
        wordBreak: 'break-all'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.advertisement {
  position: fixed;
  width: 20%;
  top: 5%;   /* 距离页面顶部的距离 */
  right: 40%; /* 距离页面右侧的距离 */
}
</style>
